var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spayd)?_c('div',{staticClass:"invoice-qr mt-3"},[_c('canvas',{ref:"qrCanvas"}),_c('div',{staticClass:"invoice-qr__label"},[_vm._v(_vm._s(_vm.$t('qr_payment')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }